import React, { useState } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import '../../styles/components/TrabajadorPrevired.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const formatear = (valor, tipo) => {
    if (valor === null || valor === undefined) return '—';
    if (tipo === 'texto') return String(valor);
    if (tipo === 'numero') return String(valor);
    return `$${Math.round(Number(valor)).toLocaleString('es-CL')}`;
};

const urlPdf = (pdf) => (pdf.startsWith('http') ? pdf : `${API_BASE_URL}/uploads/${pdf}`);

/**
 * Un trabajador del certificado de Previred, campo por campo contra su liquidación.
 *
 * Lo usan la pantalla Ver detalle, con una carga guardada que siempre cuadró, y el
 * panel de rechazo de Subir y extraer, con las diferencias de un certificado que no
 * se contabilizó. Es un solo componente para que los dos muestren lo mismo igual.
 *
 * @param {object} trabajador - un colaborador de la comparación del backend
 * @param {boolean} abiertoInicial - si el bloque parte abierto
 */
const TrabajadorPrevired = ({ trabajador, abiertoInicial = false }) => {
    const [abierto, setAbierto] = useState(abiertoInicial);

    return (
        <div className={`col-bloque ${trabajador.cuadra ? '' : 'col-bloque--difiere'}`}>
            <button
                className="col-cabecera"
                onClick={() => setAbierto(!abierto)}
                aria-expanded={abierto}
            >
                <span className="col-chevron">
                    {abierto ? <FaChevronDown /> : <FaChevronRight />}
                </span>
                <span className="col-nombre">{trabajador.nombre}</span>
                <span className="col-rut">{trabajador.rut}</span>
                <span className={`col-estado ${trabajador.cuadra ? 'ok' : 'dif'}`}>
                    {trabajador.cuadra ? 'Cuadra' : 'Con diferencias'}
                </span>
            </button>

            {abierto && (
                <div className="col-detalle">
                    <p className="col-meta">
                        {trabajador.instituciones?.length > 0 && <span>{trabajador.instituciones.join(' · ')}</span>}
                        {trabajador.estado_liquidacion && <span>Liquidación {trabajador.estado_liquidacion}</span>}
                        {trabajador.pdf_liquidacion && (
                            <a href={urlPdf(trabajador.pdf_liquidacion)} target="_blank" rel="noopener noreferrer">
                                Ver PDF de la liquidación
                            </a>
                        )}
                    </p>

                    {!trabajador.tiene_liquidacion && (
                        <p className="aviso-sin-liquidacion">
                            Este trabajador no tiene liquidación en el período.
                        </p>
                    )}

                    <table className="tabla-campos">
                        <thead>
                            <tr>
                                <th>Campo</th>
                                <th>Previred</th>
                                <th>Liquidación</th>
                                <th>Diferencia</th>
                            </tr>
                        </thead>
                        <tbody>
                            {trabajador.campos.map(campo => (
                                <tr key={campo.clave} className={campo.coincide ? '' : 'fila-difiere'}>
                                    <td>{campo.etiqueta}</td>
                                    <td className="num">{formatear(campo.previred, campo.tipo)}</td>
                                    <td className="num">{formatear(campo.liquidacion, campo.tipo)}</td>
                                    <td className="num">
                                        {campo.diferencia === null || campo.diferencia === 0
                                            ? '—'
                                            : formatear(campo.diferencia, campo.tipo)}
                                    </td>
                                </tr>
                            ))}
                            <tr className="fila-separador">
                                <td colSpan="4">
                                    Aportes del empleador — no se comparan porque la liquidación no los guarda
                                </td>
                            </tr>
                            {trabajador.informativos.map(campo => (
                                <tr key={campo.clave} className="fila-informativa">
                                    <td>{campo.etiqueta}</td>
                                    <td className="num">{formatear(campo.previred, 'monto')}</td>
                                    <td className="num">—</td>
                                    <td className="num">—</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default TrabajadorPrevired;
